import { Link } from 'react-router-dom';
import { featuredEvents } from '@/mocks/home';

const categoryLabels: Record<string, string> = {
  football: '足球',
  basketball: '篮球',
  tennis: '网球',
  esports: '电竞',
};

export default function FeaturedEvents() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <span className="text-primary-600 text-sm font-semibold tracking-wide">热门赛事</span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-2">
                精选推荐
              </h2>
              <p className="text-foreground-500 text-sm mt-2">实时赔率 · 极速结算 · 全球覆盖</p>
            </div>
            <Link
              to="/category/sports"
              className="hidden sm:flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {featuredEvents.map((event) => (
              <div
                key={event.id}
                className="bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-all duration-200 cursor-pointer group"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                    {categoryLabels[event.category] || event.category}
                  </span>
                  <div className="flex items-center gap-1.5">
                    {event.status === 'live' && (
                      <span className="flex items-center gap-1 text-accent-500 text-xs font-semibold">
                        <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
                        进行中
                      </span>
                    )}
                    {event.status === 'upcoming' && (
                      <span className="text-foreground-400 text-xs">即将开始</span>
                    )}
                  </div>
                </div>

                <p className="text-xs text-foreground-400 mb-3">{event.league}</p>

                <div className="flex items-center justify-between mb-3">
                  <div className="flex-1 text-center">
                    <p className="font-semibold text-foreground-900 text-sm whitespace-nowrap">{event.homeTeam}</p>
                    {event.homeScore !== null && (
                      <p className="text-2xl font-heading font-bold text-foreground-950 mt-1">{event.homeScore}</p>
                    )}
                  </div>
                  <div className="px-3">
                    <span className="text-xs font-semibold text-foreground-400">VS</span>
                  </div>
                  <div className="flex-1 text-center">
                    <p className="font-semibold text-foreground-900 text-sm whitespace-nowrap">{event.awayTeam}</p>
                    {event.awayScore !== null && (
                      <p className="text-2xl font-heading font-bold text-foreground-950 mt-1">{event.awayScore}</p>
                    )}
                  </div>
                </div>

                <div className="flex items-center gap-2 pt-3 border-t border-background-200">
                  {event.drawOdds ? (
                    <>
                      <div className="flex-1 text-center py-1.5 rounded bg-background-100 group-hover:bg-primary-50 transition-colors">
                        <p className="text-xs text-foreground-500">主胜</p>
                        <p className="text-sm font-bold text-primary-600">{event.homeOdds}</p>
                      </div>
                      <div className="flex-1 text-center py-1.5 rounded bg-background-100 group-hover:bg-primary-50 transition-colors">
                        <p className="text-xs text-foreground-500">平局</p>
                        <p className="text-sm font-bold text-foreground-700">{event.drawOdds}</p>
                      </div>
                      <div className="flex-1 text-center py-1.5 rounded bg-background-100 group-hover:bg-primary-50 transition-colors">
                        <p className="text-xs text-foreground-500">客胜</p>
                        <p className="text-sm font-bold text-primary-600">{event.awayOdds}</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex-1 text-center py-1.5 rounded bg-background-100 group-hover:bg-primary-50 transition-colors">
                        <p className="text-xs text-foreground-500">主胜</p>
                        <p className="text-sm font-bold text-primary-600">{event.homeOdds}</p>
                      </div>
                      <div className="flex-1 text-center py-1.5 rounded bg-background-100 group-hover:bg-primary-50 transition-colors">
                        <p className="text-xs text-foreground-500">客胜</p>
                        <p className="text-sm font-bold text-primary-600">{event.awayOdds}</p>
                      </div>
                    </>
                  )}
                </div>

                <p className="text-xs text-foreground-400 mt-3 text-center">
                  <i className="ri-time-line mr-1"></i>
                  {event.time}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center sm:hidden">
            <Link
              to="/category/sports"
              className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              查看全部赛事 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}